import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  tabWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  iconWrapper: {
    width: '28px',
    height: '28px',
    background: theme.palette.textBackground.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2.5),
    weight: 400,
    style: 'Regular',
    fontSize: '16px',
    color: theme.palette.labraText.primary,
    horizontalAlignment: 'center',
    verticalAlign: 'middle',
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '18px',
    leadingTrim: 'NONE',
    lineHeight: '27px',
    letterSpacing: '0%',
  },
  headingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  radioSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  radioHeading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontStyle: 'Medium',
    fontSize: '14px',
    leadingTrim: 'NONE',
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  inputText: {
    background: theme.palette.text.white,
    height: 'fit-content',
    alignSelf: 'center',
    borderRadius: theme.spacing(0.5),
    width: '100%',
  },
  inputSelect: {
    background: theme.palette.text.white,
    height: 'fit-content',
    alignSelf: 'center',
    borderRadius: theme.spacing(0.5),
    width: 'fit-content',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingBottom: theme.spacing(1),
  },
  widthButton: {
    width: 'fit-content',
    lineHeight: `${theme.spacing(2.5)}px !important`,
    fontSize: '14px !important',
    letterSpacing: 0.1,
    marginBottom: theme.spacing(15),
  },
}))
